import { createReducer } from '@reduxjs/toolkit'

import { activeTablesTypes, playerPrivacyStatusesEnum } from 'shared/models/LastWins'

import * as actions from '../actions'
import { ILastWinsState } from '../types'

const initialState: ILastWinsState['data'] = {
  privacySettings: {
    hideMode: playerPrivacyStatusesEnum.none,
    isNickHidden: false,
    activeTables: [],
  },
  currentActiveTable: activeTablesTypes.standard,
  slotsWinsPageSize: 10,
  slotsWinsPage: 1,
  slotsWins: {
    page: 1,
    count: 0,
    wins: [],
  },
}

export default createReducer(initialState, builder => {
  builder
    .addCase(actions.getSlotsLastWins.success, (state, action) => {
      if (action.payload) {
        state.slotsWins = action.payload
      }
    })
    .addCase(actions.updateSlotsLastWinsPage, (state, action) => {
      if (action.payload) {
        state.slotsWinsPage = action.payload
      }
    })
    .addCase(actions.getPlayerPrivacySettings.success, (state, action) => {
      if (action.payload) {
        state.privacySettings = action.payload
      }
    })
    .addCase(actions.updateSlotsLastWinsPageSize, (state, action) => {
      if (action.payload) {
        state.slotsWinsPageSize = action.payload
      }
    })
    .addCase(actions.changeActiveWinsTable, (state, action) => {
      state.currentActiveTable = action.payload
    })
})
